<div [ngClass]="editClass" class="custom-checkbox">
  <input type="checkbox" id="myCheckbox" [checked]="checkboxStatus === 'true'" [ngClass]="boxClass"
    (change)="handleCheckboxChange($event)" />
  <label *ngIf="checkBoxName" class="myCheckbox editRoles__checkBox" [ngClass]='className'
    [ngStyle]="{'color': className === 'white' ? 'white' : 'black'}">{{checkBoxName}}</label>
</div>